<template>
  <v-row>
    <v-col>
      <v-icon color="error" size="30">mdi-alert-outline</v-icon>

      <div class="textLight--text subtitle-1">
        {{ $t("somethingWentWrong") }}
      </div>

      <div
        class="textLight--text caption font-weight-regular"
        style="opacity: 0.5"
      >
        {{ $t("somethingWentWrongMessage") }}
      </div>

      <v-btn
        class="rounded-lg mt-2"
        outlined
        color="primary"
        style="text-transform: unset !important"
        @click="reload"
      >
        <v-icon left>mdi-autorenew</v-icon>
        {{ $t("refresh") }}
      </v-btn>
    </v-col>
  </v-row>
</template>

<script>
export default {
  methods: {
    reload() {
      location.reload();
    },
  },
};
</script>
